import React from "react";

import StarIcon from "@vahak/core/dist/icons/star-yellow-ratings.svg";

import Styles from "./TestimonialCardV2.module.scss";

export interface TestimonialCardV2Props {
    quote: string;
    name: string;
    role: string;
    initials: string;
}

const TestimonialCardV2 = ({ quote, name, role, initials }: TestimonialCardV2Props) => (
    <article className={Styles.card}>
        <div className={Styles.stars} aria-hidden="true">
            {Array.from({ length: 5 }).map((_, index) => (
                <StarIcon key={index} className={Styles.starIcon} />
            ))}
        </div>

        <p className={Styles.quote}>{quote}</p>

        <div className={Styles.footer}>
            <div className={Styles.avatar}>{initials}</div>
            <div className={Styles.meta}>
                <p className={Styles.name}>{name}</p>
                <p className={Styles.role}>{role}</p>
            </div>
        </div>
    </article>
);

export default TestimonialCardV2;
